import { getZrmListingInfo, getZrmUserInfo, ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

const EVENT_IDS = {
  MULTIPLEX_CONFIRM_ADDRESS_CLICK: '8719',
  MULTIPLEX_CONFIRM_UNIT_ENTRY_CLICK: '8720',
  MULTIPLEX_ADD_LISTING_DETAILS_CLICK: '8721',
  MULTIPLEX_EXPAND_UNITS: '9084',
  MULTIPLEX_COLLAPSE_UNITS: '9085',
} as const;

// https://dataportal.zillowgroup.net/event-registry/8719
const MultiplexConfirmAddressClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MULTIPLEX_CONFIRM_ADDRESS_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'yes_continue',
      trigger_object_nm: 'confirm_address_modal',
    },
    semantic: {
      semantic_event_nm: 'confirm_multiplex_location',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8720
const MultiplexConfirmUnitEntryClick = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MULTIPLEX_CONFIRM_UNIT_ENTRY_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'save_and_continue',
      trigger_object_nm: 'multiplex_unit_creation_modal',
    },
    semantic: {
      semantic_event_nm: 'create_multiplex_listings',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8721
const MultiplexAddListingDetailsClick = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MULTIPLEX_ADD_LISTING_DETAILS_CLICK,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'add_listing_details',
      trigger_object_nm: 'multiplex_unit_selection_modal',
    },
    semantic: {
      semantic_event_nm: 'create_listing',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9084
const MultiplexExpandUnits = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MULTIPLEX_EXPAND_UNITS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'expand',
      trigger_object_nm: 'multiplex_view_properties',
    },
    semantic: {
      semantic_event_nm: 'expand_multiplex_units',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/9085
const MultiplexCollapseUnits = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.MULTIPLEX_COLLAPSE_UNITS,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_source_nm: 'collapse',
      trigger_object_nm: 'multiplex_view_properties',
    },
    semantic: {
      semantic_event_nm: 'collapse_multiplex_units',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const MultiplexCSEvents = {
  MultiplexConfirmAddressClick,
  MultiplexConfirmUnitEntryClick,
  MultiplexAddListingDetailsClick,
  MultiplexExpandUnits,
  MultiplexCollapseUnits,
};

// Clickstream visualizer data-eventid attributes
MultiplexConfirmAddressClick.data_event_id = EVENT_IDS.MULTIPLEX_CONFIRM_ADDRESS_CLICK;
MultiplexConfirmUnitEntryClick.data_event_id = EVENT_IDS.MULTIPLEX_CONFIRM_UNIT_ENTRY_CLICK;
MultiplexAddListingDetailsClick.data_event_id = EVENT_IDS.MULTIPLEX_ADD_LISTING_DETAILS_CLICK;
MultiplexExpandUnits.data_event_id = EVENT_IDS.MULTIPLEX_EXPAND_UNITS;
MultiplexCollapseUnits.data_event_id = EVENT_IDS.MULTIPLEX_COLLAPSE_UNITS;

export default MultiplexCSEvents;
